
const DeleteDialougeModal = () => {

    return(
        <div className="modal fade password-model" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="close-model" data-dismiss="modal">X</div>
                        <div className="title-content">
                            <h3 className="model-title">تأكيد الحذف  </h3>
                        </div>
                        <form >
                            <div className="text-center flex ">
                                  <input className="submit-btn" type="submit" value="نعم"/>
                                  <input className="submit-btn" type="submit" value="ﻷ"/>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
         </div>
    );

};
export default DeleteDialougeModal;
